import React, { FC } from 'react'

import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { AppIcon } from '@app/components/AppIcon'
import Typography from '@mui/material/Typography'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

import { SlideMenuAccountBox, SlideMenuAccountOpenMenuSmallBtn } from './styled'

interface SlideMenuAccountProps {
	readonly minimize?: boolean
}

const SlideMenuAccount: FC<SlideMenuAccountProps> = ({
	minimize,
}: SlideMenuAccountProps) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = (): void => {
		setAnchorEl(null)
	}

	return (
		<>
			<SlideMenuAccountBox
				sx={{
					height: minimize ? '4.5rem' : '3.875rem',
					minHeight: minimize ? '3.875rem' : '3.875rem',
				}}
			>
				<SlideMenuAccountOpenMenuSmallBtn
					disableElevation
					disableRipple
					disableFocusRipple
					onClick={handleClick}
					endIcon={<ArrowDropDownIcon />}
					sx={{
						minWidth: minimize ? '16.875rem' : 'auto',
						width: minimize ? '16.875rem' : 'auto',
						marginLeft: minimize ? '1.15rem' : '0',
					}}
				>
					{minimize ? 'DARIO COACHING' : <AppIcon type={'sublist'} />}
				</SlideMenuAccountOpenMenuSmallBtn>

				{/* Typography below is temporary.
				 Just copied from previous implementation, the same as the manu below */}

				{minimize && (
					<Typography
						component='p'
						variant='h6'
						sx={{ marginLeft: '1.15rem', lineHeight: 'normal' }}
					>
						MediOrbis
					</Typography>
				)}
			</SlideMenuAccountBox>

			<Menu
				id='basic-menu'
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				sx={{
					zIndex: 2300,
				}}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
			>
				<MenuItem onClick={handleClose}>MediOrbis</MenuItem>
				<MenuItem onClick={handleClose}>Medtech</MenuItem>
				<MenuItem onClick={handleClose}>First Choice Health</MenuItem>
			</Menu>
		</>
	)
}

export default SlideMenuAccount
